import { render } from "./Index.vue?vue&type=template&id=604dc241&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=604dc241&lang=scss&scoped=true"

import exportComponent from "/Users/dongyucheng/小飞蛾/哈尔滨超付商务信息咨询服务有限公司/code/lxk_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-604dc241"]])

export default __exports__